import { useEffect } from "react";
import { DriverMarker as DriverMarkerType } from "./map.types";
import DriverMarker from "../driver-marker";
import { useMap } from "@vis.gl/react-google-maps";
import useRoutePlannerStore from "../../state/route-planner-store";

type DriverMarkersProps = {
  markers?: DriverMarkerType[];
};

const hasValidCoordinates = (lat?: number, lng?: number) =>
  Number.isFinite(lat) && Number.isFinite(lng);

const DriverMarkers = ({ markers }: DriverMarkersProps) => {
  const driverMapCentering = useRoutePlannerStore(
    (state) => state.driverMapCentering,
  );
  const setDriverMapCentering = useRoutePlannerStore(
    (state) => state.setDriverMapCentering,
  );
  const mapInstance = useMap();

  useEffect(() => {
    if (!mapInstance) return;

    if (driverMapCentering) {
      if (
        !hasValidCoordinates(driverMapCentering.lat, driverMapCentering.lng)
      ) {
        setDriverMapCentering(undefined);
        return;
      }

      const bounds = new google.maps.LatLngBounds();

      bounds.extend(
        new google.maps.LatLng(
          driverMapCentering?.lat as number,
          driverMapCentering?.lng as number,
        ),
      );

      // Reset the map state before fitting bounds
      mapInstance.setZoom(0);
      mapInstance.setCenter({ lat: 0, lng: 0 });

      // Fit the map to the bounds of the markers
      mapInstance.fitBounds(bounds);
      mapInstance.setCenter(bounds.getCenter());

      setDriverMapCentering(undefined);
    }
  }, [mapInstance, driverMapCentering, setDriverMapCentering]);

  if (!markers?.length) return;
  return markers.map((driverMarker) => (
    <DriverMarker key={driverMarker.driverId} {...driverMarker} />
  ));
};

export default DriverMarkers;
